export default {"src":"/_next/static/media/discount_24.8c11d379.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};